import instance, { get, sharePointInstance } from './request.service';
import {
  TODAY_LS_KEY,
  getEnv,
  isDevEnv,
  isPoc1ENV,
  isPoc2ENV,
  isProdEnv,
  isProdTestEnv,
  isStgEnv
} from './apiEnv.service';
import { DeriveDepartmentId } from 'utils/userFunctions.utils';
import { DEPARTMENTS } from 'components/WizardTypes/Wizard.types';
export interface IUser {
  AppRoles?: string;
  City?: string;
  CompanyName?: string;
  CostCenter?: string;
  CountryCode?: string;
  FullName?: string;
  TeamId?: number;
  UserType?: any;
  department?: string;
  departmentId?: DEPARTMENTS;
  email?: string;
  featureFlags?: any[];
  firstName?: string;
  groups?: string[];
  isAdmin?: boolean;
  isAustralia?: boolean;
  isEurope?: boolean;
  isIrvine?: boolean;
  isLakeForest?: boolean;
  isPm?: boolean;
  isPmAdmin?: boolean;
  isRSM?: boolean;
  isUS?: boolean;
  isUSCompanyUpdate?: boolean;
  lastName?: string;
  location?: string;
  permissions?: string[];
  subArea?: string;
  username?: string;
}

export interface Auth0User {
  userId: number;
  source: string;
  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  effectiveFrom: null | string;
  effectiveTo: null | string;
  country: string;
  managerSource: string;
  managerId: number;
  additionalData: null | any;
  department: string;
  departmentId?: number;
  companyName: string;
  city: string;
  costCenter: string;
  subArea: string;
  location: string;
  flags: string[];
  featureFlags: string[];
  groups: string[];
  permissions: string[];
  isImpersonated: boolean;
  originalUserId: null | number;
  originalUserSource: null | string;
  timeZone: string;
  subAreaName: string;
  state: string;
  companyCode: string;
}

export const mockUser: Auth0User = {
  status: 200,
  userName: 'ja99999',
  firstName: 'John',
  lastName: 'Appleseed',
  costCenter: '101040',
  userId: 99999,
  location: 'Rancho Santa Margarita'
};

// export const serveConstants = () => {
//   if (isProdEnv) return { origin: 'PROD', pageName: 'SUBMISSION', id: 1 };

//   if (isProdTestEnv) return { origin: 'PLAYGROUND', pageName: 'SUBMISSION_PLAYGROUND', id: 5 };

//   if (isStgEnv) return { origin: 'QA', pageName: 'SUBMISSION_QA', id: 2 };

//   if (isPoc1ENV) return { origin: 'POC1', pageName: 'SUBMISSION_POC1', id: 3 };

//   if (isPoc2ENV) return { origin: 'POC2', pageName: 'SUBMISSION_POC2', id: 4 };

//   if (isDevEnv) return { origin: 'DEV', pageName: 'SUBMISSION_DEV', id: 6 };

//   return { origin: 'DEV', pageName: 'SUBMISSION_DEV', id: 6 };
// };

export const apiEnvLookup: any = {
  'https://requests-poc1.appliedmed.com': 'POC1',
  'https://requests-poc2.appliedmed.com': 'POC2',
  'https://internal-apidev.appliedmed.com/ITProjects': 'DEV',
  'https://apidev.appliedmed.com/ITProjects': 'DEV',
  'https://internal-apiqa.appliedmed.com/ITProjects': 'QA',
  'https://apistg.appliedmed.com/ITProjects': 'QA',
  'https://apistg.appliedmed.com/ITProjects-Playground': 'PG',
  'https://internal-apiqa.appliedmed.com/ITProjects-Playground': 'PG',
  'https://api.appliedmed.com/ITProjects': 'PROD',
  'https://internal-api.appliedmed.com/ITProjects': 'PROD'
};

export const serveEnvCode = () => {
  const savedConstants: any = JSON.parse(localStorage.getItem(TODAY_LS_KEY));
  let defaultEnv = '';
  let currentEnv = '';
  if (savedConstants !== null && savedConstants !== undefined) {
    currentEnv = apiEnvLookup[savedConstants['IT_BASE_URL']];
  } else {
    currentEnv = 'PROD';
  }

  if (isProdEnv) defaultEnv = 'PROD';
  if (isProdTestEnv) defaultEnv = 'PG';
  if (isStgEnv) defaultEnv = 'QA';
  if (isPoc1ENV) defaultEnv = 'POC1';
  if (isPoc2ENV) defaultEnv = 'POC2';
  if (isDevEnv) defaultEnv = 'DEV';

  return { currentEnv, defaultEnv };
};

export const serveMaintenancePageConstants = (): {
  origin: string;
  pageName: string;
  id: number;
} => {
  if (isProdEnv)
    return {
      origin: 'PROD',
      pageName: 'ALL',
      id: 1
    };

  if (isProdTestEnv)
    return {
      origin: 'PLAYGROUND',
      pageName: 'ALL_PLAYGROUND',
      id: 5
    };

  if (isStgEnv)
    return {
      origin: 'QA',
      pageName: 'ALL_QA',
      id: 2
    };

  if (isPoc1ENV)
    return {
      origin: 'POC1',
      pageName: 'ALL_POC1',
      id: 3
    };

  if (isPoc2ENV)
    return {
      origin: 'POC2',
      pageName: 'ALL_POC2',
      id: 4
    };

  if (isDevEnv)
    return {
      origin: 'DEV',
      pageName: 'ALL_DEV',
      id: 6
    };

  return {
    origin: 'DEV',
    pageName: 'ALL_DEV',
    id: 6
  };
};

// @ts-ignore
export let isTest = window?.Cypress ? true : false;

export let isAuthenticated = false;
export let user: Auth0User = isTest ? mockUser : {};
export let RefreshToken: string;
export let JwtToken: string;
export let HasuraJwtToken: string;
export let isSignedInWithAuth0: boolean;

export const setUserWithAuth0 = async (userInfo: Auth0User) => {
  const derivedDepartmentId = DeriveDepartmentId(userInfo.costCenter);
  user = { ...userInfo, departmentId: derivedDepartmentId };

  console.log('userInfo', user);
};

export const setUserCypress = (userData: any) => {
  user = userData;
};

export const setIsSignedInWithAuth0 = (string: any) => {
  isSignedInWithAuth0 = string;
};

/**
 * TBD: removed for auth0
 */
export const updateGlobalJWT = async (jwt: any) => {
  let oldToken = JwtToken;
  // console.log(`------updateGlobalJWT:\n https://jwt.io/?value=${jwt}`);
  instance.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
  JwtToken = jwt;
};

export const updateDecisionGlobalJWT = (jwt: any) => {
  decisionInstance.defaults.headers.common.Authorization = `Session ${jwt}`;
};

export const updateSharePointJWT = (jwt: string) => {
  sharePointInstance.defaults.headers.common.Authorization = `Bearer ${jwt}`;
};

export const sharePointLogin = async () => {
  try {
    const { data } = await get({
      method: 'get',
      url: `${getEnv('IT_BASE_URL')}/user/get-files-auth`
    });
    updateSharePointJWT(data.access_token);
    return data.access_token;
  } catch (e) {
    console.log('e', e);
    console.log('failed to obtain sharepoint token');
  }
};
